import { INDIAN_BANKS } from '@admin-panel/utils';
import { Select } from 'antd';
const { Option } = Select;

export const BankSelector = (props: any) => {
  return (
    <Select {...props} style={{ width: 300 }} placeholder="Select a bank" showSearch allowClear>
      {INDIAN_BANKS.map((bank, index) => (
        <Option key={index} value={bank}>
          {bank}
        </Option>
      ))}
    </Select>
  );
};
